import { useState } from "react";
import { Link } from "react-router-dom";
import ContactUs from "./ContactUs";

export default function Footer() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const toggleContactModal = (e) => {
    e.preventDefault();
    setIsContactModalOpen(!isContactModalOpen);
  };

  return (
    <footer className="footer">
      {/* This is the main content container */}
      <div className="footer-content">
        {/* First Column: Info & Socials */}
        <div className="footer-col footer-col-info">
          <h3>OwnYourMoney</h3>
          <div className="social">
            <a
              href="https://www.facebook.com/people/Own-Your-Money-LLC/61581428684536/#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Own Your Money on Facebook"
            >
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/wendyguektintoh"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Wendy on LinkedIn"
            >
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/ownyourmoneync/?igsh=MXhlcmp0bGRldHd2cg%3D%3D#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Own Your Money on Instagram"
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
          </div>
          <address className="footer-contact">
            <div className="contact-info">
              Email:{" "}
              <a href="mailto:ownyourmoneync@gmail.com" className="email-link">
                OwnYourMoneyNC@gmail.com
              </a>
            </div>
            <div className="contact-info">Phone: 919-285-1689</div>
          </address>
        </div>

        {/* Second Column: Quick Links */}
        <div className="footer-col footer-col-links">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/coachingservices">Services</Link>
            </li>
            <li>
              <Link to="/workshops-seminars">Workshops & Seminars</Link>
            </li>
            <li>
              <button
                type="button"
                onClick={toggleContactModal}
                className="footer-link-button"
              >
                Contact
              </button>
            </li>
            <li>
              <Link to="/communityresources">Community Resources</Link>
            </li>
          </ul>
        </div>

        {/* Third Column: Legal */}
        <div className="footer-col footer-col-legal">
          <h3>Legal</h3>
          <ul className="footer-links">
            <li>
              <Link to="/terms" className="footer-link">
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacypolicy" className="footer-link">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/websitedisclaimer" className="footer-link">
                Website Disclaimer
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright">
        &copy; {new Date().getFullYear()} OwnYourMoney LLC. All Rights Reserved.
      </div>
      <div className="crafted-by">
        Crafted by{" "}
        <a
          href="https://scarletcodes.com"
          target="_blank"
          rel="noopener noreferrer"
          className="scarlet-codes-link"
        >
          Scarlet Codes LLC
        </a>
      </div>
      {isContactModalOpen && (
        <ContactUs onClose={() => setIsContactModalOpen(false)} />
      )}
    </footer>
  );
}
